import Vue from 'vue'
import Router from 'vue-router'
import { wxChatShare } from '../common/js/wxChatShare'

const Index = () => import('components/index/index')
const Personal = () => import('components/personal/personal')
const Tenement = () => import('components/tenement/tenement')
const MyAccount = () => import('components/my-account/my-account')
const MyAccountOrder = () => import('components/my-account-order/my-account-order')
const MyReceipt = () => import('components/my-receipt/my-receipt')
const GateLockCode = () => import('components/gate-lock/gate-lock-code')
const HouseList = () => import('components/gate-lock/house-list')
const GateExchangeCode = () => import('components/gate-lock/gate-exchange-code')
const PersonalApply = () => import('components/personal-apply/personal-apply')
const AdvanceOrder = () => import('components/advance-order/advance-order')
const RentOrder = () => import('components/rent-order/rent-order')
const Collection = () => import('components/collection/collection')
// const Repair = () => import('components/repair/repair')
// const RepairOrder = () => import('components/repair-order/repair-order')
// const RepairOrderDetail = () => import('components/repair-order/repair-order-detail')
// const Clean = () => import('components/clean/clean')
// const CleanOrder = () => import('components/clean-order/clean-order')
const AddAuth = () => import('components/auth-management/add-auth')
const PersonalMsg = () => import('components/personal-msg/personal-msg')
const PersonalManage = () => import('components/personal-manage/personal-manage')
const HouseDetail = () => import('components/house-detail/house-detail')
const PayDeposit = () => import('components/pay-deposit/pay-deposit')
const BookSeeHouse = () => import('components/book-see-house/book-see-house')
const BookState = () => import('components/book-state/book-state')
const BookStateFail = () => import('components/book-state-fail/book-state-fail')
const Reason = () => import('components/reason/reason')
const Login = () => import('components/login/login')
const Loginwechat = () => import('components/login-wechat/loginwechat')
const AddBank = () => import('components/add-bank/add-bank')
const ChooseBank = () => import('components/choose-bank/choose-bank')
const AccountDetail = () => import('components/account-detail/account-detail')
const PaymentsDetail = () => import('components/payments-detail/payments-detail')

const Withdraw = () => import('components/withdraw/withdraw')
const WithdrawSuccess = () => import('components/withdraw-success/withdraw-success')
const WechatPayment = () => import('../components/wechat-payment/index')
const protocols = () => import('../components/login/protocols')
const Contract = () => import('components/contract/contract')
const CheckContractDetail = () => import('components/check-contract-detail/check-contract-detail')
const OfflineContractDetail = () => import('components/check-contract-detail/offline-contract-detail')
const Refuse = () => import('components/refuse/refuse')
const ConfirmOrder = () => import('components/confirm-order/confirm-order')
const FeeDetail = () => import('components/fee-detail/fee-detail')
const checkPersonalApply = () => import('components/check-personal-apply/check-personal-apply')
const wechatLbs = () => import('components/wechat-lbs/index')
const orderChoose = () => import('components/order-choose/order-choose')
const applyToLive = () => import('components/apply-to-live/apply-to-live')
const wechatbind = () => import('components/wechat-bind/wechatbind')
const allHouseList = () => import('components/all-house-list/all-house-list')
const houseListIndex = () => import('components/house-list-index/house-list-index')
const nearbyProperty = () => import('components/nearby-property/nearby-property')
const processSlider = () => import('components/nearby-property/process-slider')
const chooseArea = () => import('components/choose-area/choose-area')
const filterHouse = () => import('components/filter-house/filter-house')
const near = () => import('components/near/near')
const changeRenter = () => import('components/change-renter/change-renter')
const residents = () => import('components/residents/residents')
const exchangeSuccess = () => import('components/exchange-success/exchange-success')
const historyBillDetails = () => import('components/history-bill-details/history-bill-details')
const billDetails = () => import('components/bill-details/bill-details')
const costItem = () => import('components/bill-details/cost-item')
const renewDetails = () => import('components/renew-details/renew-details')
const applyEarnest = () => import('components/apply-earnest/apply-earnest')
const elecContract = () => import('components/elec-contract/elec-contract')
const contractContent = () => import('components/elec-contract/contract-content')
const convenientAuth = () => import('components/convenient-auth/convenient-auth')
const independentBuilding = () => import('components/independent-building/independent-building')
const exchangeApply = () => import('components/home-exchange/exchange-apply')
const exchangeList = () => import('components/home-exchange/exchange-list')
const exchangedetail = () => import('components/home-exchange/exchange-detail')

const shareCode = () => import('components/share-code/share-code')               //门禁分享
const shareRecord = () => import('components/share-code/share-record')           //门禁分享记录
const getCodeSucceed = () => import('components/share-code/get-code-succeed')   //获取验证码验证成功
const setCodeSucceed = () => import('components/share-code/set-code-succeed')     //门禁验证码验证成功
const verifyImportCode = () => import('components/share-code/verify-import-code') //访客门禁系统

const foreignApply = () => import('components/personal-apply/foreign-apply')
const faceRecognition = () => import('components/personal-manage/face-recognition')
const autoForm = () => import('components/personal-apply/auto-form')
const veifyFail = () => import('components/personal-manage/veify-fail')
const personalStatus = () => import('components/personal-status/personal-status')
const guide = () => import('components/share-code/guide')
const addTeam = () => import('components/team-rent/add-team')
const teamOrder = () => import('components/team-order/team-manage')
const teamIntention = () => import('components/team-order/team-intention')
const teamDetails = () => import('components/team-order/team-details')
const teamRefuse = () => import('components/team-order/team-refuse')
const teamHistory = () => import('components/team-order/team-history')
const teamConfirm = () => import('components/team-order/team-confirm')
const teamCostDetails = () => import('components/team-order/team-cost-details')
const teamRecognition = () => import('components/team-order/team-recognition')
const teamBill = () => import('components/team-order/team-bill')
const teamPerson = () => import('components/team-order/team-person')
const roomList = () => import('components/residents/room-list')
const shareGuide = () => import('components/share-guide/share-guide')
const checkOut = () => import('components/check-out/check-out')
const topicCltc = () => import('components/topic/topic_cltc')
const videoDemo = () => import('components/house-detail/video-demo')
const filterTopic = () => import('components/topic/filter-topic')
const websiteType1 = () => import('components/costom-website/website-type1')
const websiteType2 = () => import('components/costom-website/website-type2')
const websiteType3 = () => import('components/costom-website/website-type3')
const websiteType4 = () => import('components/costom-website/website-type4')
const searchHouse = () => import('components/search-house/search-house')
const downloadPdf = () => import('components/download/download-pdf')
const message = () => import('components/message')
const chat = () => import('components/message/chat')

// import demo from 'components/demo'
import axios from 'axios'

let login = (to, from, next) => {
  let token = localStorage.getItem('token')
  if (!token) {
    next({ path: '/login' })
  } else {
    next()
  }
}

let pay = (to, from, next) => {
  if (typeof WeixinJSBridge !== 'undefined') {
    next()
  } else {
    Toast('请在微信中支付')
  }
}

Vue.use(Router)

const router = new Router({
  mode: 'history',
  hash: false,
  hashbang: false,
  routes: [
    {
      path: '/',
      component: Index,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: '/index',
      component: Index,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: '/personal',
      name: 'personal',
      component: Personal,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      },
    },
    {
      path: '/tenement',
      component: Tenement
    },
    {
      path: '/my-account',
      component: MyAccount,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/my-account-order',
      component: MyAccountOrder,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/my-receipt',
      name: 'my-receipt',
      component: MyReceipt,
      meta: {
        requireAuth: true,
        keepAlive: true
      },
    },
    {
      path: '/gate-lock-code',
      component: GateLockCode,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/house-list',
      component: HouseList,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/gate-exchange-code',
      component: GateExchangeCode,
      name: GateExchangeCode,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/personal-apply',
      name: 'personal-apply',
      component: PersonalApply,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: '/advance-order',
      name: 'advance-order',
      component: AdvanceOrder,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/rent-order',
      name: 'rent-order',
      component: RentOrder,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/collection',
      component: Collection,
      meta: {
        requireAuth: true,
      },
    },
    // {
    //   path: '/repair',
    //   name: 'repair',
    //   component: Repair
    // },
    // {
    //   path: '/repair-order',
    //   name: 'repair-order',
    //   component: RepairOrder,
    //   meta: {
    //     requireAuth: true,
    //   },
    // },
    // {
    //   path: '/repair-order-detail',
    //   name: 'repair-order-detail',
    //   component: RepairOrderDetail,
    //   meta: {
    //     requireAuth: true,
    //   },
    // },
    // {
    //   path: '/clean',
    //   name: 'clean',
    //   component: Clean,
    //   meta: {
    //     requireAuth: true,
    //   },
    // },
    // {
    //   path: '/clean-order',
    //   name: 'clean-order',
    //   component: CleanOrder,
    //   meta: {
    //     requireAuth: true,
    //   },
    // },
    {
      path: '/personal-msg',
      name: 'personal-msg',
      component: PersonalMsg,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/personal-manage',
      name: 'personal-manage',
      component: PersonalManage,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/house-detail',
      name: 'house-detail',
      component: HouseDetail,
      meta: {
        fullPath: true
      }
    },
    {
      path: '/pay-deposit',
      name: 'pay-deposit',
      component: PayDeposit,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/book-see-house',
      name: 'book-see-house',
      component: BookSeeHouse,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/order-choose',
      name: 'order-choose',
      component: orderChoose,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/apply-to-live',
      name: 'apply-to-live',
      component: applyToLive
    },
    {
      path: '/book-state',
      name: 'book-state',
      component: BookState,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/book-state-fail',
      name: 'book-state-fail',
      component: BookStateFail
    },
    {
      path: '/reason',
      name: 'reason',
      component: Reason
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/loginwechat',
      name: 'loginwechat',
      component: Loginwechat
    },
    {
      path: '/add-bank',
      component: AddBank
    },
    {
      path: '/choose-bank',
      component: ChooseBank
    },
    {
      path: '/account-detail',
      component: AccountDetail
    },
    {
      path: '/payments-detail',
      component: PaymentsDetail
    },
    {
      path: '/withdraw',
      component: Withdraw
    },
    {
      path: '/withdraw-success',
      component: WithdrawSuccess
    },
    {
      path: '/pay/wechat-payment',
      component: WechatPayment
    },
    {
      path: '/protocols',
      component: protocols
    },
    {
      path: '/contract',
      component: Contract
    },
    {
      path: '/check-contract-detail',
      component: CheckContractDetail
    },
    {
      path: '/offline-contract-detail',
      component: OfflineContractDetail
    },
    {
      path: '/refuse',
      component: Refuse
    },
    {
      path: '/confirm-order',
      component: ConfirmOrder
    },
    {
      path: '/fee-detail',
      component: FeeDetail
    },
    {
      path: '/check-personal-apply',
      component: checkPersonalApply
    },
    {
      path: '/wechat-lbs',
      component: wechatLbs
    },
    {
      path: '/wechat-bind',
      name: 'wechatbind',
      component: wechatbind
    },
    {
      path: '/house-list-index',
      component: houseListIndex
    },
    {
      path: '/all-house-list',
      component: allHouseList
    },
    {
      path: '/nearby-property',
      component: nearbyProperty
    },
    {
      path: '/process-slider',
      component: processSlider
    },
    {
      path: '/choose-area',
      component: chooseArea
    },
    {
      path: '/near',
      component: near,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: '/filter-house',
      component: filterHouse
    },
    {
      path: '/renew-details',
      component: renewDetails
    },
    {
      path: '/history-bill-details',
      name: 'history-bill-details',
      component: historyBillDetails
    },
    {
      path: '/cost-item',
      name: 'cost-item',
      component: costItem
    },
    {
      path: '/bill-details',
      name: 'bill-details',
      component: billDetails
    },
    {
      path: '/apply-earnest',
      name: 'apply-earnest',
      component: applyEarnest
    },
    {
      path: '/elec-contract',
      name: 'elec-contract',
      component: elecContract
    },
    {
      path: '/convenient-auth',
      name: 'convenient-auth',
      component: convenientAuth
    },
    {
      path: '/independent-building',
      name: 'independent-building',
      component: independentBuilding,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/contract-content',
      name: 'contract-content',
      component: contractContent
    },
    {
      path: '/change-renter',
      name: 'change-renter',
      component: changeRenter
    },
    {
      path: '/residents',
      name: 'residents',
      component: residents
    },
    {
      path: '/exchange-success',
      name: 'exchange-success',
      component: exchangeSuccess
    },
    {
      path: '/add-auth',
      name: 'add-auth',
      component: AddAuth
    },
    {
      path: '/exchang-apply',
      name: 'exchang-apply',
      component: exchangeApply
    },
    {
      path: '/exchange-list',
      name: 'exchange-list',
      component: exchangeList
    },
    {
      path: '/exchange-detail',
      name: "exchange-detail",
      component: exchangedetail
    },
    {

      path: '/share-code',
      name: "share-code",
      component: shareCode
    },
    {
      path: '/share-record',
      name: "share-record",
      component: shareRecord
    },
    {
      path: '/get-code-succeed',
      name: "get-code-succeed",
      component: getCodeSucceed
    },
    {
      path: '/set-code-succeed',
      name: "set-code-succeed",
      component: setCodeSucceed
    },
    {
      path: '/verify-import-code',
      name: "verify-import-code",
      component: verifyImportCode
    },
    {
      path: '/foreign-apply',
      name: 'foreign-apply',
      component: foreignApply
    },
    {
      path: '/face-recognition',
      name: 'face-recognition',
      component: faceRecognition
    },
    {
      path: '/auto-form/',
      name: 'auto-form',
      component: autoForm
    },
    {
      path: '/veify-fail',
      name: 'veify-fail',
      component: veifyFail
    },
    {
      path: '/personal-status',
      name: 'personal-status',
      component: personalStatus
    },
    {
      path: '/guide',
      name: 'guide',
      component: guide
    },
    {
      path: '/add-team',
      name: 'add-team',
      component: addTeam,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/team-manage',
      name: 'team-manage',
      component: teamOrder,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/team-intention',
      name: 'team-intention',
      component: teamIntention,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/team-details',
      name: 'team-details',
      component: teamDetails,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/team-refuse',
      name: 'team-refuse',
      component: teamRefuse,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/team-history',
      name: 'team-history',
      component: teamHistory,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/team-confirm',
      name: 'team-confirm',
      component: teamConfirm,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/team-cost-details',
      name: 'team-cost-details',
      component: teamCostDetails,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/team-recognition',
      name: 'team-recognition',
      component: teamRecognition,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/team-bill',
      name: 'team-bill',
      component: teamBill,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/team-person',
      name: 'team-person',
      component: teamPerson,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/room-list',
      name: 'room-list',
      component: roomList
    },
    {
      path: '/share-guide',
      name: 'share-guide',
      component: shareGuide
    },
    {
      path: '/check-out',
      name: 'check-out',
      component: checkOut
    },
    {
      path: '/topic_cltc/:id',
      component: topicCltc,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: '/topic_cltc/:id/:from',
      component: topicCltc,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: '/video-demo',
      component: videoDemo,

    },
    {
      path: '/filter-topic',
      component: filterTopic,

    },
    {
      path: '/website-type1',
      component: websiteType1,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/website-type2',
      component: websiteType2,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/website-type3',
      component: websiteType3,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/website-type4',
      component: websiteType4,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/search-house',
      component: searchHouse,
    },
    {
      path: '/download-pdf',
      component: downloadPdf
    },
    {
      path: '/message',
      component: message
    },
    {
      path: '/chat',
      component: chat
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

router.beforeEach((to, from, next) => {

  // 微信自定义分享
  let wechaturl = window.location.protocol + '//' + window.location.host + to.fullPath;
  wxChatShare(
    {
      title: '驿住租房', // 分享标题
      desc: '用驿住，做甩手房东', // 分享描述
      url: wechaturl,
      link: wechaturl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: window.location.protocol + '//' + window.location.host + '/static/share.jpg', // 分享图标
    }
  )
  next();
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js